<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<a
  [routerLink]="link"
  [queryParams]="params"
  class="btn btn-info btn-ico"
  [ngbTooltip]="'PREVIEW_BUTTON.PREVIEW' | translate"
  container="body"
>
  <i class="fal fa-eye"></i>
</a>
